import { OverviewRsvpStatusesUI } from '@bridebook/web/lib/guestlist/constants';
import { TFunction } from 'next-i18next';

export const getRsvpStatusTranslation = (rsvpStatus: OverviewRsvpStatusesUI, t: TFunction) => {
  switch (rsvpStatus) {
    case OverviewRsvpStatusesUI.pending:
      return t('guestlist:filterRSVPStatusPending');
    case OverviewRsvpStatusesUI.responded:
      return t('guestlist:filterRSVPStatusResponded');
  }
};
